import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import { get, map, keys, includes } from 'lodash'

import { Input } from 'Components/Form/Input'
import { Dropzone } from 'Components/Form/Dropzone'
import SubmitButton from 'Components/Form/SubmitButton'
import { SectionLabel } from 'Components/Section/SectionLabel'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { SectionWrapper } from 'Components/Section/SectionWrapper'
import { SubmitButtonBlock } from 'Components/Form/SubmitButton/SubmitButtonBlock'

import { required, zeroRequired, email } from 'Utils/Validators/formValidation'

import { getCities } from 'Reducers/City/actions'
import { getClients } from 'Reducers/Clients/actions'

import { USER_STATUSES } from 'Reducers/Users/const'
import { authorization } from 'Module/Auth/Auth'
import { CONFIG } from 'Config/config'

import { isClientRole } from 'Utils/Validators/roles'
import { validate } from './validate'

const statusOptions = [
  {
    label: 'Active',
    value: USER_STATUSES.active,
  },
  {
    label: 'Pending',
    value: USER_STATUSES.pending,
  },
  {
    label: 'Blocked',
    value: USER_STATUSES.blocked,
  },
]

const roleOptions = {
  [CONFIG.USER_ROLE.ADMIN]: {
    label: 'Administrator',
    value: CONFIG.USER_ROLE.ADMIN,
  },
  [CONFIG.USER_ROLE.CITY_MANAGER]: {
    label: 'City Manager',
    value: CONFIG.USER_ROLE.CITY_MANAGER,
  },
  [CONFIG.USER_ROLE.CLIENT_ADMIN]: {
    label: 'Client Admin',
    value: CONFIG.USER_ROLE.CLIENT_ADMIN,
  },
  [CONFIG.USER_ROLE.CLIENT]: {
    label: 'Client',
    value: CONFIG.USER_ROLE.CLIENT,
  },
  [CONFIG.USER_ROLE.RECRUITER]: {
    label: 'Recruiter',
    value: CONFIG.USER_ROLE.RECRUITER,
  },
}

const setRoles = availableRoles =>
  map(roleOptions, (data, roleName) => ({
    ...data,
    disabled: !includes(availableRoles, roleName),
  }))

const roleOptionsByUserRole = {
  [CONFIG.USER_ROLE.ADMIN]: setRoles(keys(roleOptions)),
  [CONFIG.USER_ROLE.CITY_MANAGER]: setRoles([
    CONFIG.USER_ROLE.CITY_MANAGER,
    CONFIG.USER_ROLE.CLIENT,
  ]),
  [CONFIG.USER_ROLE.CLIENT_ADMIN]: setRoles([
    CONFIG.USER_ROLE.CLIENT_ADMIN,
    CONFIG.USER_ROLE.CLIENT,
  ]),
  [CONFIG.USER_ROLE.CLIENT]: setRoles([CONFIG.USER_ROLE.CLIENT]),
  [CONFIG.USER_ROLE.RECRUITER]: setRoles([CONFIG.USER_ROLE.RECRUITER]),
}

class UserManagementDetailsAddForm extends PureComponent {
  componentDidMount = ({ getCities, getClients } = this.props) => {
    getCities()
    getClients()
  }

  render = ({ handleSubmit, cities, clients } = this.props) => (
    <form>
      <SectionWrapper className="section-wrapper first">
        <SectionTitle className="section-title">User Details</SectionTitle>
        <Col xs={12}>
          <Col xs={10}>
            <Row>
              <Col xs={3}>
                <SectionLabel className="section-label">
                  First Name
                </SectionLabel>
                <Field
                  component={Input}
                  id="firstName"
                  name="firstName"
                  validate={[required]}
                />
              </Col>
              <Col xs={3}>
                <SectionLabel className="section-label">Last Name</SectionLabel>
                <Field
                  component={Input}
                  id="lastName"
                  name="lastName"
                  validate={[required]}
                />
              </Col>
              <Col xs={3}>
                <SectionLabel className="section-label">
                  Mobile Phone
                </SectionLabel>
                <Field
                  component={Input}
                  id="mobilePhone"
                  name="mobilePhone"
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <SectionLabel className="section-label">Password</SectionLabel>
                <Field
                  component={Input}
                  type="password"
                  id="password"
                  name="password"
                  validate={[required]}
                />
              </Col>
              <Col xs={3}>
                <SectionLabel className="section-label">
                  Repeat Password
                </SectionLabel>
                <Field
                  component={Input}
                  type="password"
                  id="repeatPassword"
                  name="repeatPassword"
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <SectionLabel className="section-label">
                  Email Address
                </SectionLabel>
                <Field
                  component={Input}
                  id="email"
                  name="email"
                  validate={[required, email]}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <SectionLabel className="section-label">Role</SectionLabel>
                <Field
                  component={SelectDashboard}
                  name="role"
                  props={{
                    options:
                      roleOptionsByUserRole[authorization.getUser().role],
                    sorted: true,
                  }}
                  validate={[required]}
                />
              </Col>
              {isClientRole(this.props.activeRole) ? (
                <Col xs={3}>
                  <SectionLabel className="section-label">Client</SectionLabel>
                  <Field
                    component={SelectDashboard}
                    id="client"
                    name="clientId"
                    props={{
                      options: clients,
                      sorted: true,
                    }}
                    validate={[required]}
                  />
                </Col>
              ) : (
                <Col xs={3}>
                  <SectionLabel className="section-label">City</SectionLabel>
                  <Field
                    component={SelectDashboard}
                    name="cityId"
                    props={{
                      options: cities,
                      sorted: true,
                    }}
                    validate={[required]}
                  />
                </Col>
              )}
              <Col xs={3}>
                <SectionLabel className="section-label">Status</SectionLabel>
                <Field
                  component={SelectDashboard}
                  name="status"
                  props={{
                    options: statusOptions,
                    sorted: true,
                  }}
                  validate={[zeroRequired]}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={2}>
            <Col xs={3}>
              <Field
                component={Dropzone}
                id="profilePicture"
                name="profilePicture"
              />
            </Col>
          </Col>
        </Col>
      </SectionWrapper>
      <SubmitButtonBlock>
        <SubmitButton value="Save" onClick={handleSubmit} />
      </SubmitButtonBlock>
    </form>
  )
}

UserManagementDetailsAddForm.propTypes = {
  activeRole: PropTypes.string,
}

const mapStateToProps = state => ({
  activeRole: get(state, 'form[user-details-add.values].role'),
  cities: state.city.citiesList.map(c => ({ value: c.id, label: c.name })),
  clients: state.clients.clientsList.map(c => ({ value: c.id, label: c.name })),
})

UserManagementDetailsAddForm = reduxForm({
  form: 'user-details-add',
  validate,
})(UserManagementDetailsAddForm)

UserManagementDetailsAddForm = connect(
  mapStateToProps,
  { getCities, getClients },
)(UserManagementDetailsAddForm)

export { UserManagementDetailsAddForm }



// WEBPACK FOOTER //
// ./src/Containers/Form/UserManagement/UserDetails/Add/index.js